import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LoginComponent} from './login/login.component';
import {AuthService} from './auth.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastrModule} from 'ngx-toastr';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {NgSelectModule} from '@ng-select/ng-select';
import {AgmCoreModule} from '@agm/core';
import {NgxSpinnerModule} from 'ngx-spinner';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ReactiveFormsModule} from '@angular/forms';
import localeEsBo from '@angular/common/locales/es-BO';
import {registerLocaleData} from '@angular/common';
import {SweetAlert2Module} from '@sweetalert2/ngx-sweetalert2';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {Interceptor} from './interceptor';
import {StoreModule} from '@ngrx/store';
import {appReducers} from './store/app.reducer';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {environment} from '../environments/environment.prod';
import {EffectsModule} from '@ngrx/effects';
import {effectsArray} from './store/effects';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {IConfig, NgxMaskModule} from 'ngx-mask';

registerLocaleData(localeEsBo, 'es-Bo');
const maskConfig: Partial<IConfig> = {
  validation: true,
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent
  ],
  imports: [
    BrowserModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyARNwoGhPASCLbiwTExQXQWo6rMHssOYvk&libraries',
      libraries: ['geometry']
    }),
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    NgxMaskModule.forRoot(maskConfig),
    AppRoutingModule,
    HttpClientModule,
    NgSelectModule,
    NgxSpinnerModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    SweetAlert2Module.forRoot(),
    TooltipModule.forRoot(),
    StoreModule.forRoot(appReducers),
    EffectsModule.forRoot(effectsArray),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
    ButtonsModule.forRoot(),
  ],
  providers: [{provide: LOCALE_ID, useValue: 'es-Bo'}, AuthService, {
    provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true
  }],
  bootstrap: [AppComponent]
})
export class AppModule {
}
